import Collection from '@/components/sections/builder/elements/body/collection-list/collection';
import { CollectionListElementDataType } from '@/components/sections/builder/elements/body/collection-list/type';
import ElementContent from '@/components/sections/builder/elements/body/collection-list/content';
import ElementSetting from '@/components/sections/builder/elements/body/collection-list/setting';
import { Tags } from 'lucide-react';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

export const defaultData: CollectionListElementDataType = {
  name: 'Collection List',
  contentAlign: 'left',
  headingLabel: 'Collections',
  colorSchemeCollectionList: DEFAULT_THEME_COLOR_SCHEME,
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  imageRatio: 'square',
  isShowViewAll: false,
  totalCol: 4,
  totalColMobile: 'two_columns',
  size: 'small',
  rounded: 2,
  labelViewAll: 'View all',
  positionViewAll: 'bottom',
  viewAllStyle: 'default',
  desktopLayout: 'row',
  imageRadius: 0,
  styleCollection: '',
  itemTitleSize: 20,
  itemDescriptionSize: 15,
  showViewCollection: false,
  labelViewCollection: 'View Collection',
  viewCollectionPosition: 'left',
  showDescription: true,
};

export const ElementPreviewIcon = Tags;

const CollectionList = {
  type: 'collection_list',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Collection],
  childs: [Collection],
};

export default CollectionList;
